import { render, staticRenderFns } from "./Interessado.vue?vue&type=template&id=04c420bb"
import script from "./Interessado.vue?vue&type=script&lang=js"
export * from "./Interessado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports